import { Provider } from "react-redux";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Forgot from "./pages/Forgot";
import Home from "./pages/Home";
import Login from "./pages/Login";
import VerifyEmailForRegistration from "./pages/verifyEmailForRegistration";
import Registration from "./pages/Registration";
import Reset from "./pages/Reset";
import { store } from "./store";
import Protected from "./components/Protected";
import EndToEnd from "./pages/EndToEnd";

const App = () => {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          <Route path={"/"} element={<Protected Component={Home} />} />
          <Route path={"/:id"} element={<Protected Component={EndToEnd} />} />
          <Route path={"/login"} element={<Login />} />
          <Route path={"/registration"} element={<Registration />} />
          <Route path={"/forgot"} element={<Forgot />} />
          <Route
            path={"/complete-registration"}
            element={<VerifyEmailForRegistration />}
          />
          <Route path={"/reset"} element={<Reset />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  );
};

export default App;
